const options = {
  5: "bg-emerald-500/5",
  10: "bg-emerald-500/10",
  25: "bg-emerald-500/25",
  50: "bg-emerald-500/50",
  75: "bg-emerald-500/75",
  90: "bg-emerald-500/90",
  100: "bg-emerald-500",
};

const from = {
  5: "from-emerald-500/5",
  10: "from-emerald-500/10",
  25: "from-emerald-500/25",
  50: "from-emerald-500/50",
  75: "from-emerald-500/75",
  90: "from-emerald-500/90",
  100: "from-emerald-500",
};

export default function getBackgroundEmerald500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
